import { cn } from '@discover-lib/utils';

function Root({ className, ...props }: React.ComponentPropsWithoutRef<'span'>) {
  return <span className={cn('cursor-help leading-snug', className)} {...props} />;
}

type LoadingIconProps = {
  loading: boolean;
  count: number;
};

export default function LoadingIcon({ loading, count }: LoadingIconProps) {
  if (loading) {
    return <Root title="Loading...">⏳</Root>;
  }

  if (!count) {
    return <Root title="Empty">⚪️</Root>;
  }

  return <Root title="Done">🟢</Root>;
}
